<table class="table table-striped">
  <thead>
    <tr>
      <th>Source</th>
      <th>Référence</th>
      <th>Catégorie</th>
      <th>Type</th>
      <th>Statut</th>
      <th>Base</th>
      <th>Supplément</th>
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>{{ carRentalRecord.carRentalProvider || ' - ' }}</td>
      <td>{{ carRentalRecord.carRentalBookingReference || ' - ' }}</td>
      <td>{{ carRentalRecord.carRentalCategory || ' - ' }}</td>
      <td>
          {{ carRentalRecord.carRentalMandatory ? 'Obligatoire' : 'Optionnelle' }}
      </td>
      <td>
        <span [class.green-colored]="carRentalRecord.status === 'OK'"
              [class.red-colored]="carRentalRecord.status !== 'OK'">
          {{ carRentalRecord.status || ' - ' }}
        </span>
      </td>
      <td>
        {{ carRentalRecord.carRentalMandatory
          ? ' inclus '
          : (basePrice ? basePrice.toFixed(2) + ' €' : ' - ')
        }}
      </td>
      <td>
        {{ supplementPrice ? supplementPrice.toFixed(2) + ' €' : ' - ' }}
      </td>
      <td>
        {{ carRentalRecord.carRentalMandatory
          ? (supplementPrice ? supplementPrice.toFixed(2) + ' €' : ' inclus ')
          : (totalPrice ? totalPrice.toFixed(2) + ' €' : ' - ')
        }}
      </td>
    </tr>
  </tbody>
</table>

<div class="mt-3" *ngIf="carRentalRecord.carRentalDetails">
  <h6>Nom : {{ carRentalRecord.carRentalName }}</h6>
  <h6>Détails : {{ carRentalRecord.carRentalDetails }}</h6>
</div>